// extracted by mini-css-extract-plugin
export default {"container":"ImageThumbnail_container__TdCHk","loaded":"ImageThumbnail_loaded__IRbH9","thumbnail":"ImageThumbnail_thumbnail__LV-Ze","remove":"ImageThumbnail_remove__7KU9-"};